<template>
  <div>
    <gmap-marker
      v-for="hub in hubs"
      :key="`cl-${hub.id}`"
      :position="hub.point"
      :icon="getIcon('CollectionLocation')"
    ></gmap-marker>

    <gmap-marker
      v-for="location in locations"
      :key="`pl-${location.location.id}`"
      :position="location.location.point"
      :icon="getIcon(location.type, location.entity)"
      :options="{ zIndex: getIcon(location.type, location.entity).zIndex }"
      v-if="location && location.location.point"
    ></gmap-marker>

    <gmap-marker
      v-if="lasso && lasso.length > 0"
      :position="lasso[0]"
      :icon="getIcon('LassoConnect')"
      @click="onLassoConnectClick"
    />
    <gmap-polyline
      v-if="lasso && lasso.length > 1"
      :path="lasso"
    ></gmap-polyline>

    <div class="modal is-active" v-if="!route">
      <div class="modal-background"></div>
      <form @submit.prevent="onCreateSubmit">
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Create Route</p>
            <button type="button" class="delete" @click.prevent="onCancel"></button>
          </header>
          <section class="modal-card-body">
            <div class="field">
              <label>Depature Site</label>
              <div class="control">
                <div class="select is-fullwidth">
                  <select name="departureSiteId" required>
                    <option v-for="hub in hubs" :key="hub.id" :value="hub.id">{{ hub.name }}</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="field">
              <label>Return Site</label>
              <div class="control">
                <div class="select is-fullwidth">
                  <select name="returnSiteId" required>
                    <option v-for="hub in hubs" :key="hub.id" :value="hub.id">{{ hub.name }}</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="field">
              <label>Scheduled Date</label>
              <div class="control">
                <input type="date" class="input" name="scheduledDate" required>
              </div>
            </div>
          </section>
          <footer class="modal-card-foot is-right">
            <button type="button" class="button" @click="onCancel">Cancel</button>
            <button class="button is-success">Select Locations</button>
          </footer>
        </div>
      </form>
    </div>

    <article class="message is-info" v-if="showMessage">
      <div class="message-header">
        <p>Lassoing Locations</p>
        <button class="delete" aria-label="delete" @click="showMessage = false"></button>
      </div>
      <div class="message-body">
        <p>
          You are now lassoing locations. To do this click around the area you
          want to make a route for. The first click will place a red dot. This
          is the "Lasso Connect". Once you are done drawing your lasso click
          back on it to connect the lasso area and make a route.
        </p>
      </div>
    </article>

    <div class="route-list box" v-if="route && route.locations">
      <div class="header">
        <h1 class="title is-4 has-text-centered">New Route</h1>
        <hr>
      </div>

      <div class="list">
        <route-detail class="detail" v-for="(detail, index) in routeDetails" :detail="detail" :key="index">
          {{ detail }}
        </route-detail>
      </div>

      <div class="controls has-text-centered" v-if="routeSummary">
        <hr>
        <strong>{{ routeSummary.weight | toWeight }}</strong> - 
        <strong>{{ routeSummary.duration.text }}</strong>&nbsp;
        <small>({{ routeSummary.distance.text }})</small> -
        <small>{{ routeSummary.count }} Stops</small>
      </div>

      <div class="controls">
        <hr>
        <nav class="level">
          <div class="level-left"></div>
          <div class="level-right">
            <div class="level-item">
              <button class="button" @click="onCancel">Cancel</button>
            </div>
            <!--div class="level-item">
              <button class="button is-warning" @click="onConfirmEdit">Edit</button>
            </div-->
            <div class="level-item">
              <button class="button is-primary" @click="onContinue">Continue</button>
            </div>
          </div>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import * as Helpers from '../MapperHelpers'

import RouteDetail from '../Components/RouteDetail.vue'

export default {
  name: 'MapperCreateRoute',

  props: [
    'status',
    'routes',
    'locations',
    'hubs'
  ],

  data () {
    return {
      route: null,
      lasso: null,

      showMessage: false,
      renderer: null
    }
  },

  methods: {
    getIcon: Helpers.getIcon,

    onCancel () {
      this.$emit('update:status', 'Overview')
    },

    onCreateSubmit (e) {
      const data = {};

      for (const element of e.target.elements) {
        if (element.name) {
          data[element.name] = element.value
        }
      }

      this.route = {
        departureSite: this.hubs.find(location => location.id == data.departureSiteId),
        returnSite: this.hubs.find(location => location.id == data.returnSiteId),
        scheduledDate: data.scheduledDate
      }

      this.lasso = []
      this.showMessage = true

      this.$parent.$mapObject.addListener('click', this.onMapClick)
    },

    async onConfirmEdit () {
      this.$dialog.confirm({
        message: 'If you edit this route, it will no longer be optimized',
      })
    },

    async onContinue () {
      const loader = this.$loading.open()
      try {
        let route = (await this.$entity.create('Route', {
          name: this.route.route.summary,
          departureSiteId: this.route.departureSite.id,
          returnSiteId: this.route.returnSite.id,
          scheduledDate: this.route.scheduledDate,
          plannedDuration: Helpers.secondsToTimeSpan(this.routeSummary.duration.value),
          plannedRoutePath: {
            points: Helpers.decodePolyline(this.route.route.overview_polyline)
          }
        })).data

        await this.$http.post('/Stops/Batch/ServiceStop', this.route.locations.map((location, index) => ({
          routeId: route.id,
          stopNumber: index + 1,
          pickupRequestId: location.location.PickupRequests.find(pr => !pr.isClosed) ? location.location.PickupRequests.find(pr => !pr.isClosed).id : undefined,
          pickupLocationId: location.location.id
        })))

        this.$entity.toView('Route', route.id)
      } catch (e) {
        console.error(e)
        this.$handleError('There was an error creating the route', e.response.data)
      } finally {
        loader.close()
      }
    },

    onMapClick (e) {
      if (this.lasso) {
        this.lasso.push({
          lat: e.latLng.lat(),
          lng: e.latLng.lng()
        })
      }
    },

    async onLassoConnectClick (e) {
      if (this.lasso.length <= 3) {
        return
      }

      const loader = this.$loading.open()
      try {
        if (this.lasso.length > 3) {
          this.lasso.push(this.lasso[0])

          const intersection = Helpers.getIntersection(this.lasso, this.locations)

          if (intersection.length > 23) {
            this.$snackbar.open({
              message: 'You cannot have more than 23 stops assigned to a route.',
              type: 'is-danger'
            })
            this.$emit('update:status', 0)
            return;
          }

          const { route, locations } = await Helpers.calculateRoute(this.route.departureSite, this.route.returnSite, intersection)

          this.renderer = new google.maps.DirectionsRenderer()
          this.renderer.setMap(this.$parent.$mapObject)
          this.renderer.setDirections(route)

          this.route = {
            ...this.route,
            editting: false,
            route: route.routes[0],
            locations
          }

          this.showMessage = false
        }
      } catch (e) {
        console.error(e)
      } finally {
        loader.close()
      }
    }
  },

  destroyed () {
    if (this.renderer) {
      this.renderer.setMap(null)
    }
  },

  computed: {
    routeDetails () {
      try {
        if (this.route && this.route.locations && this.route.route) {
          const details = []
  
          const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'

          details.push({
            ...this.route.departureSite,
            type: 'CollectionLocation',
            letter: letters[0]
          })

          const locations = this.route.locations.slice(0)
          for (let i = 0; i < this.route.route.legs.length; i++) {
            details.push({
              ...this.route.route.legs[i],
              type: 'Leg'
            })
  
            const location = locations.shift()
            if (location) {
              details.push({
                ...location,
                type: 'PickupRequest',
                letter: letters[i + 1]
              })
            }
          }
  
          details.push({
            ...this.route.returnSite,
            type: 'CollectionLocation',
            letter: letters[1 + this.route.locations.length]
          })
  
          return details
        }
  
        return undefined
      } catch (e) {
        console.error(e)
        return undefined
      }
    },

    routeSummary () {
      if (this.route && this.route.route && !this.route.editting) {
        let summary = {
          weight: 0,
          distance: {
            value: 0,
            text: ''
          },
          duration: {
            value: 0,
            text: ''
          }
        }

        summary = this.route.route.legs.reduce((summary, leg) => {
          summary.distance.value += leg.distance.value
          summary.duration.value += leg.duration.value
          return summary
        }, summary)

        summary = this.route.locations.reduce((summary, location) => {
          if (location.type === 'PickupRequest') {
            if (location.entity.isStockPile) {
              summary.duration.value += 60 * 60 // 60 minutes per stockpile
              summary.weight += location.entity.estimatedWeight
            } else if (location.entity.isRecaptureBag) {
              summary.duration.value += 12 * 60 // 12 minutes for recapture bag
              summary.weight += location.entity.estimatedWeight
            } else {
              if (location.location.Dumpsters.length > 0) {
                summary.duration.value += (5 * 60) * location.location.Dumpsters.length // 5 minutes per dumpster
                summary.weight += 1000 * location.location.Dumpsters.length // 1000 lbs per dumpsters
              } else {
                summary.duration.value += 8 * 60 // 8 minutes is the default for On Farm Time
                summary.weight += 1000 // 1000 If no dumpsters present
              }
            }
          } else {
            if (location.location.Dumpsters.length > 0) {
              summary.duration.value += (5 * 60) * location.location.Dumpsters.length // 5 minutes per dumpster
              summary.weight += 1000 * location.location.Dumpsters.length // 1000 lbs per dumpsters
            } else {
              summary.duration.value += 8 * 60 // 8 minutes is the default for On Farm Time
              summary.weight += 1000 // 1000 If no dumpsters present
            }
          }

          return summary
        }, summary)

        summary.duration.text = Helpers.secondsToDuration(summary.duration.value)
        summary.distance.text = `${(summary.distance.value / 1609.34).toFixed(1)} mi`
        summary.count = this.route.locations.length || 0

        return summary
      }
    }
  },

  components: {
    RouteDetail
  }
}
</script>

<style lang="scss" scoped>
  .message {
    position: absolute;
    left: unset !important;
    bottom: unset !important;
    top: 4rem;
    right: 1rem;
    max-width: 25vw;
  }

  .route-list {
    position: absolute;
    top: 4rem;
    right: 1rem;
    bottom: 1rem;
    display: flex;
    flex-direction: column;

    width: 350px;

    .header {
      flex: 0 0 auto;
    }

    .list {
      flex: 1 1 auto;
      overflow-y: auto;
      overflow-x: visible;
      margin-left: -1rem;
      margin-right: -1rem;
      padding: .5rem;

      .detail {
        border-bottom: #cccccc 1px solid;
      }
    }

    .controls {
      flex: 0 0 auto;
    }
  }
</style>
